import { jwtDecode as decode } from "jwt-decode";

const REFRESH_THRESHOLD_SEC = 30;

export function shouldAuthenticate(request: Request) {
  const SKIP_AUTHENTICATION_PATHS = ["/auth", "/config", "/login"];

  if (SKIP_AUTHENTICATION_PATHS.some((path) => request.url.includes(path))) {
    return false;
  }

  return true;
}

export function isTokenExpiringSoon(token: string) {
  const { exp } = decode(token);

  if (!exp) {
    return false;
  }

  return exp - Date.now() / 1000 <= REFRESH_THRESHOLD_SEC;
}
